import {GetSortedMenuSections, TypecastPillAction} from './properties-menu/types';
import type {ChildMenu} from './child-menu';
import {ModalType, QueryBlockTheme, SelectorType} from './constants';

export enum MenuType {
  Breakdown = `breakdown`,
  Cohorts = `cohorts`,
  Events = `events`,
  Filter = `filter`,
  Properties = `properties`,
  Segment = `segment`,
  Tabbed = `tabbed`,
  Time = `time`,
  TimeComparison = `time-comparison`,
  MultiEvents = `multi-events`,
}

export type IncludeCustomPropertySetting = `none` | `persisted-only` | `persisted-non-behavioral-only` | `all`;

export type QueryBlockState = {
  childMenu: ChildMenu<any>;
  isHeaderMenuOpen: boolean;
  isMenuOpen: boolean;
  openedMenuForModal: boolean;
  searchFilter: string;
  openModal: ModalType;

  // TODO: Add types for these
  eventData: any;
  selected: any;
  staged: any; // TODO: being used in breakdown-menu, this should be removed
  tooltipData: any;
  keydownProxyEl: any;
  getSortedMenuSections: GetSortedMenuSections;
};

export type QueryBlockAttrs = {
  type: MenuType;
  'all-data-groups': boolean;
  'allow-behavioral-property-creation': boolean;
  'allow-typecast-pill-action'?: TypecastPillAction;
  'apply-button': string;
  'apply-button-disabled': boolean;
  autofocus: boolean;
  'data-group-id': string;
  'date-range': any; // {type: `json`, description: `Only for time-comparison menu type`},
  disabled: boolean;
  'disabled-items': `json`;
  'display-context'?: string;
  'enable-enhanced-list-filters': boolean;
  'enable-workspace-filter-restrictions': boolean;
  'disable-value-selection': boolean;
  'exclude-autotrack-events': boolean;
  'exclude-custom-events': boolean;
  'force-old-dropdowns'?: boolean;
  'include-custom-properties': IncludeCustomPropertySetting;
  'exclude-dimension-properties': boolean;
  'exclude-lookup-table-properties': boolean;
  'excluded-elements': any; // {type: `json`, default: []},
  'event-names': any; // {type: `json`, default: null},
  'header-segments': any; // `json`,
  'header-text': string;
  'help-text': string;
  'input-only': boolean;
  tooltip: any; // {type: `json`,}
  'is-blocked-people': boolean;
  label: string;
  'max-data-history-days': number;
  multiple: boolean;
  open: boolean;
  'prefix-label': string;
  'hide-prefix-label': boolean;
  'property-combine-mode': string; // {type: `string`, default: null},
  'hide-events': boolean;
  'project-has-people': boolean;
  'project-has-cohorts': boolean;
  'project-id': number;
  readonly: boolean;
  removable: boolean;
  'dropdown-alignment': string;
  selected: any; // {type: `json`, default: null},
  inverted: boolean;
  'selector-icon': string;
  'selector-type': SelectorType;
  'show-any-event': boolean;
  'show-session-event': boolean;
  'show-all-events': boolean;
  'show-all-tab': boolean;
  'show-all-users-cohort': boolean;
  'show-top-events': boolean;
  'single-data-group': string;
  'support-b2b-cohorts': boolean;
  'inline-cohorts-override': any; // `json`,
  'hide-edit-controls': boolean;
  'show-special-date-property': boolean;
  'hide-special-date-property-unit': boolean;
  'show-special-dataset-property': boolean;
  theme: QueryBlockTheme;
  tabs: any; //`json`,
  'track-name': string;
  'other-group-by-options': string;
  'other-filter-options': string;
  'user-id': number;
  'workspace-id': number;
  'project-as-of-date': string;
  'search-placeholder': string;
  'show-select-all': boolean;
  'select-all-disabled': boolean;
  'hide-recently-viewed': boolean;
  'hide-section-labels': boolean;
  'selectable-sensitive-properties': boolean;
  'menu-item-types': any; // json,
};
